import { logError } from 'commons/logger';
import isChunkLoadError from '@/utils/isChunkLoadError';

// A failed posthog-js download is a dropped connection or an ad blocker, not a bug
const handlePostHogInitError = error => {
  if (isChunkLoadError(error)) return;
  logError(error, 'Error initializing PostHog client');
};

export default handlePostHogInitError;
